export enum BanxicoErrorCodeEnum {
    ACCOUNT_VALIDATION = 3,
    ALREADY_REGISTERED = -12,
    WRONG_RFC = -21
}

export enum AuthOErrorCodeEnum {
    AUTH0_IDP_ERROR = "auth0_idp_error"
}